import React from 'react'

import { RichTextStatic } from 'components/rich-text/RichTextStatic'

import { useOnMount } from 'hooks/useOnMount'
import {
  InnskraningAnalyticsStepEnum,
  trackInnskraningEvent,
} from 'utils/onboarding/analytics'
import { scrollToTopOfPage } from 'utils/scrollToTopOfPage'

const renderWhatNext = ({
  isKassar,
  offerType,
}: {
  isKassar: boolean
  offerType: string | null
}) => {
  if (isKassar) {
    return (
      <>
        <h2>Hvenær koma kassarnir?</h2>
        <p>Flutningskassarnir verða keyrðir heim til þín innan skamms.</p>
        <p>
          Afhending á höfuðborgarsvæðinu tekur að jafnaði 1-2 virka daga en
          afhending utan höfuðborgarsvæðisins getur tekið ögn lengri tíma.
        </p>
      </>
    )
  } else if (offerType === 'svellid') {
    return (
      <>
        <h2>Hvað gerist næst?</h2>
        <p>
          Þú þarft ekkert að gera, við göngum frá skiptunum og heyrum í þér
          eftir 2-3 daga. Þangað til getur þú haldið þér í stuði á Stuðsvellinu.
          Hlökkum til að sjá þig!
        </p>
      </>
    )
  } else {
    return (
      <>
        <h2>Hvað gerist næst?</h2>
        <p>
          Þú þarft ekki að gera neitt, en við munum nú ganga frá skiptunum og þú
          heyrir aftur frá okkur eftir 2-3 daga.
        </p>
      </>
    )
  }
}

export const Success = ({
  isKassar,
  offerType,
}: {
  isKassar: boolean
  offerType: string | null
}) => {
  useOnMount(() => {
    scrollToTopOfPage()
    trackInnskraningEvent(InnskraningAnalyticsStepEnum.SUCCESS_PAGELOAD)
  })

  return (
    <RichTextStatic>
      <p>
        Við erum afar glöð með að þú hafir valið Orkusöluna og höfum nú fengið
        allar upplýsingar sem þarf til að ganga frá málunum.
      </p>
      <p>
        Þú ættir að fá tölvupóst til staðfestingar á netfangið þitt eftir
        örstutta stund.
      </p>
      {renderWhatNext({ isKassar, offerType })}
    </RichTextStatic>
  )
}
